import SvgIcon from '@mui/material/SvgIcon';

export default function DropdownArrow() {
    return (
        <SvgIcon
            sx={{
                color: '#007BFF',
                fontSize: '1.5rem',
                position: 'absolute',
                right: '4px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',

            }}
        >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 12L16 20L8 12" stroke="#212121" stroke-width="2.66667" />
            </svg>
        </ SvgIcon>
    );
}
